import { FC, useState } from 'react';
import Link from 'next/link';
import { parseISO, format } from 'date-fns';
import VersionSticker from '../version-sticker/VersionSticker';
import { IBook, IAuthor } from '@/interfaces/home.interface';
import { IPodcastAuthor } from '@/interfaces/podcastsPage.interface';
import { hideImgOnError, getAuthorFullName, getTruncatedTxt } from '@/helpers/helpers';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import styles from './BookCardItem.module.scss';

interface IBookCardItem {
  book: IBook | any;
  author: IAuthor | any;
  authors?: IPodcastAuthor[];
  rating: number;
  id: number;
  createdAt?: string;
  dataName?: string;
  isPodcast?: boolean;
  isAuthor?: boolean;
  freeVersion?: boolean;
  type?: string;
}

const BookCardItem: FC<IBookCardItem> = ({ id, book, author, authors, rating, createdAt, dataName, isPodcast, isAuthor, freeVersion, type }) => {
  const { title, description, external_id } = book;
  const { first_name, middle_name, last_name, id: authorId } = author;
  const authorFullName = getAuthorFullName(first_name, middle_name, last_name);
  const bookRating = Number(rating);

  const bookAlias = book.allow_full_free === 1 && book.type !== 'book' ? `/online/${id}` : `/book/${id}`;
  const podcastAlias = `/library/podcasts/${id}`;
  const bookFullAlias = isPodcast ? podcastAlias : bookAlias;
  const authorFullAlias = `/library/author/${authorId}`;

  const [isCardShowInfo, setIsCardShowInfo] = useState(false);

  return (
    <div className={isCardShowInfo ? `${styles.bookCard} ${styles.bookCard_infoActive}` : `${styles.bookCard}`} data-card={dataName}>
      <div className={styles.bookCard__wrap}>
        <div>
          <div className={styles.bookCard__image}>
            <Link prefetch={false} className={styles.bookCard__imageLink} href={bookFullAlias}>
              <img loading="lazy" width="174" height="247" src={`${DEV_ABSOLUTE_URL}/covers_185/${external_id}.jpg`} alt={title} onError={hideImgOnError} />
            </Link>
            {freeVersion && type !== 'pdf' && <VersionSticker />}
            <span className={styles.bookCard__mobButton} onClick={() => setIsCardShowInfo(true)}></span>
            {/* {% include "blocks/draft_sticker.twig" %} */}
          </div>
        </div>

        <div className={styles.bookCard__desc}>
          <div className={styles.bookCard__title}>
            <Link prefetch={false} href={bookFullAlias}>
              {title}
            </Link>
          </div>
          <div className={styles.bookCard__author}>
            {isPodcast ? (
              <>
                {authors?.map((author: IPodcastAuthor) => (
                  <span className={`${styles.bookCard__authorLink} ${styles.bookCard__authorLink_noHover}`} key={author.alias}>
                    {getAuthorFullName(author.first_name, author.middle_name, author.last_name)}{' '}
                  </span>
                ))}
              </>
            ) : (
              <>
                {isAuthor ? (
                  <div className={`${styles.bookCard__authorLink} ${styles.bookCard__authorLink_noHover}`}>{authorFullName}</div>
                ) : (
                  <Link prefetch={false} className={styles.bookCard__authorLink} href={authorFullAlias}>
                    {authorFullName}
                  </Link>
                )}
              </>
            )}
          </div>

          <div className={bookRating > 1 ? `${styles.bookCard__rating}` : `${styles.bookCard__rating} ${styles.bookCard__rating_zero}`}>
            <span className={styles.bookCard__ratingNumber}>{bookRating > 5 ? 5 : bookRating}</span>
          </div>
          {!!createdAt && createdAt!.length > 0 && (
            <div className={`${styles.bookCard__addDate} ${styles.bookCard__addDate_tile}`}>
              Добавлена: <time dateTime={createdAt}>{format(parseISO(createdAt!), 'dd.MM.yyyy')}</time>
            </div>
          )}
          <div className={styles.bookCard__txt}>{getTruncatedTxt(description, 250)}</div>
          <div className={styles.bookCard__hideButton} onClick={() => setIsCardShowInfo(false)}></div>
        </div>
      </div>
      <div className={`${styles.bookCard__txt} ${styles.bookCard__txt_mob}`}>{getTruncatedTxt(description, 250)}</div>
      {!!createdAt && createdAt!.length > 0 && (
        <div className={styles.bookCard__addDate}>
          Добавлена: <time dateTime={createdAt}>{format(parseISO(createdAt!), 'dd.MM.yyyy')}</time>
        </div>
      )}
    </div>
  );
};

export default BookCardItem;
